import React from 'react';
import AdminLayout from '../../components/templates/layout/AdminLayout';
import SentimentAnalysisManagement from '../../components/templates/admin/SentimentAnalysisManagement';

const SentimentAnalysisPage = () => {
  return (
    <AdminLayout>
      <SentimentAnalysisManagement />
    </AdminLayout>
  );
};

export default SentimentAnalysisPage;
